import React from 'react';
import { Box, Icon, Tooltip } from '@mui/material';
import {
  SparkEllipsisTypography,
  SparkTruncatedTypography,
} from 'sharedComponents/UI';
import { SparkImageLoader } from 'sharedComponents/UI';
import { fileTypeToIconMap } from 'components/common/Chats/AttachmentCard';
import { RawFileIcon } from 'components/SVG/fileType';

export default function TaggedParameter({
  output,
  label,
  onClick,
  iconURL = '',
  fileTypeTag = '',
}: {
  output: string;
  label?: string | undefined | null;
  onClick: () => void;
  iconURL?: string;
  fileTypeTag?: string;
}) {
  return (
    <Box
      paddingX={1}
      paddingY={0.5}
      gap={1}
      sx={{
        border: '1px solid #eee',
        marginX: 1,
        borderRadius: '10px',
        alignItems: 'center',
        display: 'flex',
        background: '#fff',
        cursor: 'pointer',
        '&:hover': {
          outline: (theme) => `1px solid ${theme.palette.primary.main}`,
          bgcolor: '#fff',
        },
      }}
      onClick={onClick}
    >
      {iconURL ? (
        <Box marginTop={0.5} alignSelf='flex-start'>
          <SparkImageLoader
            src={iconURL}
            alt='step-reference-iconURL'
            width='20px'
            height='20px'
          />
        </Box>
      ) : (
        <Icon
          sx={{
            width: '20px',
            height: '20px',
            position: 'relative',
            '& svg': {
              height: 'inherit',
            },
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'start',
          }}
        >
          {fileTypeToIconMap[fileTypeTag.toLowerCase()] || <RawFileIcon />}
        </Icon>
      )}
      <SparkTruncatedTypography typographyProps={{ variant: 'body2' }}>
        {!!label && (
          <Tooltip title={label}>
            <Box
              sx={{
                display: 'inline-flex',
                borderRadius: '3px',
                marginRight: 1,
                height: '32px',
                alignItems: 'center',
                justifyContent: 'center',
                paddingX: 1.5,
                bgcolor: (theme) => theme.palette.primary.light,
                '& p': {
                  fontFamily: 'Mont-SemiBold',
                  fontSize: '14px',
                },
              }}
            >
              <SparkEllipsisTypography
                variant='body2'
                sx={{ WebkitLineClamp: 1 }}
              >
                {label}
              </SparkEllipsisTypography>
            </Box>
          </Tooltip>
        )}
        {output}
      </SparkTruncatedTypography>
    </Box>
  );
}
